<script setup lang="ts">
defineProps<{
  iframeSrcdoc: string;
  isLoading?: boolean;
  isVisible: boolean;
  title: string;
}>();

const emit = defineEmits<{
  close: [];
}>();

const handleClose = () => {
  emit('close');
};
</script>

<template>
  <Modal
    :is-visible="isVisible"
    :title="title"
    fullscreen
    hide-close
    transparent-overlay
    @close="handleClose"
  >
    <div :class="$style.modalBody">
      <iframe
        v-if="isVisible"
        :class="$style.iframe"
        :srcdoc="iframeSrcdoc"
        title="Регистрация Timepad"
      />
      <div v-if="isLoading" :class="$style.loaderOverlay">
        <Loader center small />
      </div>
    </div>
  </Modal>
</template>

<style module lang="scss">
.modalBody {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: transparent;
}

.iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  background: transparent;
}

.loaderOverlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(2px);
}
</style>
